import { decodePurchaseHistoryOrderNumber } from "features/purchaseHistory/purchaseHistoryOrderPath";
import { usePurchaseHistoryApiFlag } from "features/purchaseHistory/usePurchaseHistoryApiFlag";
import { useEffect } from "react";
import { useHistory } from "react-router";

import { useOrderDetailFromApi } from "./hooks/useOrderDetailFromApi";
import { useOrderDetailFromFirestore } from "./hooks/useOrderDetailFromFirestore";
import { useReceiptState } from "./hooks/useReceiptState";

import type { PATH_PARAMETERS } from "constants/pathParameters";
import type { GetParameters } from "types/GetParameters";

type Parameters = GetParameters<
  [(typeof PATH_PARAMETERS)["/account/settlement/history/:orderId"]]
>;

type Input = {
  parameters: Parameters;
};

export const useThis = (input: Input) => {
  const {
    parameters: { orderId: orderIdParameter },
  } = input;
  const history = useHistory();
  const isApiEnabled = usePurchaseHistoryApiFlag();

  // URLの識別子は画面に出す注文番号そのもの
  const orderId = decodePurchaseHistoryOrderNumber(orderIdParameter);

  // 両方のhookは常に呼び、フラグで有効な側だけが取得する
  const fromFirestore = useOrderDetailFromFirestore({
    enabled: !isApiEnabled,
    orderId,
  });
  const fromApi = useOrderDetailFromApi({
    enabled: isApiEnabled,
    orderId,
  });
  const detail = isApiEnabled ? fromApi : fromFirestore;

  const {
    isDisplayReceipt,
    isReceiptAvailable,
    receiptData,
    handleShowReceipt,
    handleCloseReceipt,
  } = useReceiptState({
    orderData: detail.orderData,
    orderList: detail.orderList,
  });

  useEffect(() => {
    if (detail.isInvalid) history.replace("/account/settlement/history");
  }, [detail.isInvalid, history]);

  const handleCopyOrderId = async (orderId: string) => {
    await navigator.clipboard.writeText(orderId);
  };

  return {
    deliveryData: detail.deliveryData,
    fulfillmentData: detail.fulfillmentData,
    handleCloseReceipt,
    handleContinuePayment: detail.handleContinuePayment,
    handleCopyOrderId,
    handleShowReceipt,
    isDisplayReceipt,
    isFetchError: detail.isFetchError,
    isLoadingAddress: detail.isLoadingAddress,
    isLoadingBonus: detail.isLoadingBonus,
    isLoadingFulfillment: detail.isLoadingFulfillment,
    isPayPalPending: detail.isPayPalPending,
    isPurchased: detail.isPurchased,
    isReceiptAvailable,
    orderData: detail.orderData,
    orderList: detail.orderList,
    receiptData,
    renderConfirmCvsPayment: detail.renderConfirmCvsPayment,
    showPaymentAlert: detail.showPaymentAlert,
  };
};
